import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, GitCompareArrows } from "lucide-react";
import { getCompare, setCompare } from "@/lib/api";

export function CompareBar() {
    const [selection, setSelection] = useState(() => getCompare());
    useEffect(() => {
        const h = () => setSelection(getCompare());
        window.addEventListener("gc-compare-changed", h);
        return () => window.removeEventListener("gc-compare-changed", h);
    }, []);

    if (selection.length === 0) return null;

    return (
        <div className="fixed bottom-14 md:bottom-5 inset-x-3 sm:inset-x-auto sm:right-6 sm:left-auto z-40 md:max-w-lg" data-testid="compare-bar">
            <div className="rounded-2xl bg-navy text-white shadow-2xl border border-white/10 px-4 py-3 flex items-center gap-3">
                <GitCompareArrows className="h-5 w-5 text-gold shrink-0" />
                <div className="flex-1 flex flex-wrap gap-1.5 min-w-0">
                    {selection.map((s) => (
                        <span key={s.slug} className="inline-flex items-center gap-1 rounded-full bg-white/10 text-[11px] font-bold px-2.5 py-1 max-w-[140px]">
                            <span className="truncate">{s.name}</span>
                            <button onClick={() => setCompare(selection.filter((x) => x.slug !== s.slug))} aria-label={`Remove ${s.name}`} data-testid={`compare-remove-${s.slug}`} className="text-white/60 hover:text-white shrink-0"><X className="h-3 w-3" /></button>
                        </span>
                    ))}
                    {selection.length < 2 && <span className="text-[11px] text-white/50 self-center">Pick {2 - selection.length} more to compare</span>}
                </div>
                <Link
                    to="/compare"
                    data-testid="compare-now-btn"
                    className={`shrink-0 rounded-full px-4 py-2 text-[11px] font-display font-black uppercase tracking-wider transition-colors ${selection.length >= 2 ? "bg-saffron hover:bg-saffron-dark text-white" : "bg-white/10 text-white/40 pointer-events-none"}`}
                >
                    Compare
                </Link>
            </div>
        </div>
    );
}
